<oph-page-header
  [title]="'Teams'"
  [description]="'Manage your teams'"
  [primaryActionButtonText]="'Add Team'"
  [primaryActionButtonIcon]="'plus-white'"
  (primaryActionButtonChange)="addTeam()"
  (searchInputChange)="onSearchChange($event)"
/>
